<template>
  <div class="tag-group-content">
    <el-menu default-active="tag-manage" class="el-menu-demo" mode="horizontal" :router="true">
      <el-menu-item index="list">竞赛管理</el-menu-item>
      <el-menu-item index="tag-manage" class="right is-active">标签课程</el-menu-item>
      <el-menu-item index="category" class="right">分类管理</el-menu-item>
    </el-menu>

    <div class="tab-item">
      <el-menu class="el-menu-demo" mode="horizontal" :router="true">
        <el-menu-item index="tag-manage">标签管理</el-menu-item>
        <el-menu-item index="tag-group-manage" class="is-active">标签组管理</el-menu-item>
      </el-menu>
      <div class="add-box">
        <el-button type="primary" @click="dialogTagGroupVisible = true">添加标签组</el-button>
      </div>
      <template>
        <el-table :data="tableData" style="width: 100%" :header-cell-style="{background:'#f5f5f5',color:'#555'}">
          <el-table-column prop="name" label="标签组名称" width="300"></el-table-column>
          <el-table-column prop="scope" label="应用于" width="400">
            <template slot-scope="scope">
              {{scope.row.scope | filterScope}}
            </template>
          </el-table-column>
          <el-table-column prop="tagNum" label="包含标签数量" width="150"></el-table-column>
          <el-table-column label="操作" align="right">
            <template slot-scope="scope">
              <el-button size="mini" @click="editTagGroup(scope.row.id,scope.row.name,scope.row.scope)">编辑</el-button>
              <el-button size="mini" @click="deleteTagGroup(scope.row.id,scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog :title="tempId?'编辑标签组':'添加标签组'" width="600px" :visible.sync="dialogTagGroupVisible" :close-on-click-modal="false" :before-close="cancelTagGroup">
          <el-form :model="tagGroupValue" ref="tagGroupForm" :rules="tagGroupRules" label-width="100px" @submit.native.prevent>
            <el-form-item label="标签组名称" prop="name">
              <el-input v-model.trim="tagGroupValue.name" placeholder="请输入标签组名称" autocomplete="off" autofocus="true"></el-input>
            </el-form-item>
            <el-form-item label="用于" prop="scope">
              <el-checkbox-group v-model="tagGroupValue.scope">
                <el-checkbox label="course">比赛列表筛选</el-checkbox>
                <el-checkbox label="training">训练列表筛选</el-checkbox>
                <el-checkbox label="classroom">专题列表筛选</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="包含标签" prop="tags">
              <el-select v-model="tagGroupValue.tags" multiple filterable allow-create default-first-option placeholder="请输入标签" :remote-method="loadAllTags" :loading="loading"
                style="width:100%;">
                <el-option v-for="item in tagsOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <span style="font-size:12px;">回车可添加标签，标签组内添加的标签也会添加到标签管理中</span>
            </el-form-item>
          </el-form>
          <template slot="footer">
            <el-button type="primary" @click="addTagGroup">确定</el-button>
            <el-button @click="cancelTagGroup">取消</el-button>
          </template>
        </el-dialog>
      </template>
    </div>
  </div>
</template>

<script>
import {
  getTagData,
  addTagData,
  editTagData,
  deleteTagData,
  checkTagName,
  getTagGroupData,
  addTagGroupData,
  editTagGroupData,
  deleteTagGroupData,
  checkTagGroupName,
  getTagsInGroup,
  loadAllTagsData
} from "@/api/course";
import qs from "qs";
export default {
  components: {},
  mounted() {
    this.initTagGroupData();
  },
  watch: {

  },
  data() {

    var tagGroupValidator = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入标签组名称'));
      }
      if (value.length > 20) {
        return callback(new Error('标签组名称的长度必须小于等于20'));
      }
      let params = {
        exclude: this.tempName,
        value: value
      }
      checkTagGroupName(params).then(response => {
        if (!response.data.success) {
          callback(new Error('标签组已存在'));
        } else {
          callback()
        }
      })
    };
    var Group_tagValidator = (rule, value, callback) => {
      if (!value.length) {
        return callback(new Error('标签组内标签不能为空'))
      }
      callback()
    }
    return {
      tableData: [], //标签数据
      dialogTagGroupVisible: false,//标签组添加窗口
      tagGroupValue: {
        name: '',
        scope: [],
        tags: []
      },
      tagGroupRules: {
        name: [
          { required: true, validator: tagGroupValidator, trigger: "blur" },
        ],
        tags: [
          { required: true, validator: Group_tagValidator, trigger: "blur" },
        ]
      },
      tempId: "",//临时的标签id
      tempName: '',//临时的标签名
      checkList: [],//标签组-->用于 数据
      tags: [],//标签组包含的标签
      tagsOptions: [],//标签组可选择的标签
      loading: false,
    };
  },
  methods: {

    //获取标签组
    initTagGroupData: function () {
      getTagGroupData().then(response => {
        this.tableData = response.data.tagGroups
      })
    },
    //添加标签组
    addTagGroup: function () {
      this.$refs["tagGroupForm"].validate(valid => {
        if (valid) {
          let params = {
            name: this.tagGroupValue.name,
            scope: this.tagGroupValue.scope,
            tags: this.tagGroupValue.tags.join(',')
          };
          if (!this.tempId) {
            addTagGroupData(qs.stringify(params)).then(response => {
              if (response.code === 200) {
                this.tableData.unshift(response.data.tagGroup);
                this.$message.success("添加成功!");
              } else {
                this.$message.success("添加失败!");
              }
            })
          } else {
            let index = this.tableData.findIndex((val) => {
              return val.id == this.tempId
            })
            editTagGroupData(this.tempId, qs.stringify(params)).then(response => {
              if (response.code === 200) {
                if (index !== -1) {
                  this.tableData.splice(index, 1, response.data.tagGroup);
                }
                this.$message.success("保存成功!");
              } else {
                this.$message.success("保存失败!");
              }
            })
          }
          this.cancelTagGroup();
        }
      })
    },
    //编辑标签组
    editTagGroup: function (id, name, scope) {
      this.dialogTagGroupVisible = true;
      this.tagGroupValue.name = name;
      this.tagGroupValue.scope = scope;
      this.tempId = id;
      this.tempName = name;
      let params = {
        id: id
      }
      getTagsInGroup(params).then(response => {
        this.tagGroupValue.tags = response.data.tags
      })
    },
    //删除标签组
    deleteTagGroup: function (id, index) {
      this.$confirm("真的要删除该标签组吗？", "删除标签组", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = {
          id: id
        };
        this.tableData.splice(index, 1);
        deleteTagGroupData(params).then(response => {
          this.$message.success("删除成功!");
        });
      })
        .catch(() => { });
    },
    //关闭添加标签组窗口
    cancelTagGroup: function () {
      this.$refs.tagGroupForm.resetFields(); //关闭前清空表单
      this.dialogTagGroupVisible = false;
      this.tempId = "";
      this.tempName = "";
      this.tagGroupValue = {
        name: '',
        scope: [],
        tags: []
      }
    },
    //加载所有标签
    loadAllTags: function () {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          // this.options = this.list.filter(item => {
          //   return item.label.toLowerCase()
          //     .indexOf(query.toLowerCase()) > -1;
          // });
        }, 200);
      } else {

        this.tagsOptions = [];
      }
    },
  },
  filters: {
    //标签组数据内-》应用于筛选,data是数组scope
    filterScope: function (data) {
      let str = ''
      if (data.length) {
        data.forEach(element => {
          if (element === 'course') {
            str += ' 比赛列表筛选'
          } else if (element === 'training') {
            str += ' 训练列表筛选'
          } else if (element === 'classroom') {
            str += ' 专题列表筛选'
          }
        });
      }
      return str;
    }
  },
  directives: {
    focus: {
      inserted: function (el, { value }) {
        //聚焦元素
        el.querySelector("input").focus();
        el.querySelector("input").select();
      }
    }
  }
};
</script>

<style scoped>
.tag-group-content {
  background-color: #ffffff;
  padding: 20px;
  overflow: auto;
}
.tag-group-content .el-menu {
  margin-bottom: 15px;
}
.tag-group-content .tab-item .el-menu-item {
  line-height: 45px;
  height: 45px;
}
.tag-group-content .tab-item .el-menu-item.is-active {
  border: 1px solid #dce1e6;
  border-bottom-color: #fff;
  color: #409eff;
}
.tag-group-content .tab-item {
  position: relative;
}
.tag-group-content .add-box {
  position: absolute;
  top: -5px;
  right: 0;
}
</style>
